import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/logo_open.svg';
const _withScopeId = n => (_pushScopeId("data-v-71d136be"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header",
  ref: "head"
};
const _hoisted_2 = {
  class: "h-nav open-nav"
};
const _hoisted_3 = {
  class: "h-logo"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "体验中心", -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "n-list"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "n-left"
}, null, -1));
const _hoisted_9 = {
  class: "n-right"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "split"
}, null, -1));
export default {
  __name: 'openNav',
  setup(__props) {
    const basePath = window.appConfig.VUE_APP_PATH;
    const goPage = async url => {
      window.open(window.appConfig[url], '_blank');
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _directive_track = _resolveDirective("track");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        to: _unref(basePath)
      }, {
        default: _withCtx(() => [_hoisted_4]),
        _: 1
      }, 8, ["to"]), _createElementVNode("div", {
        class: "nav-txt nav-txt-experience",
        onClick: _cache[0] || (_cache[0] = $event => goPage('openDemoUrl'))
      }, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_router_link, {
        to: _unref(basePath),
        class: "back"
      }, {
        default: _withCtx(() => [_createTextVNode("返回官网")]),
        _: 1
      }, 8, ["to"]), _hoisted_10, _withDirectives((_openBlock(), _createElementBlock("a", {
        href: "javascript:;",
        onClick: _cache[1] || (_cache[1] = $event => goPage('openLoginUrl'))
      }, [_createTextVNode("登录/注册")])), [[_directive_track, {
        button_name: '登录/注册',
        click_info: '顶部导航栏_登录/注册',
        event_source: '顶部导航',
        event_source_pam: null,
        event_target: '亲笔签登录页',
        event_target_pam: null
      }]]), _withDirectives((_openBlock(), _createElementBlock("a", {
        href: "javascript:;",
        class: "n-test",
        onClick: _cache[2] || (_cache[2] = $event => goPage('openRegistUrl'))
      }, [_createTextVNode("成为开发者")])), [[_directive_track, {
        button_name: '免费试用',
        click_info: '顶部导航栏_免费试用',
        event_source: '顶部导航',
        event_source_pam: null,
        event_target: '留资表单',
        event_target_pam: null
      }]])])])])], 512);
    };
  }
};